import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=47245ed2&scoped=true"
import script from "./pay.js?vue&type=script&lang=js&external"
export * from "./pay.js?vue&type=script&lang=js&external"
import style0 from "./pay.vue?vue&type=style&index=0&id=47245ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47245ed2",
  null
  
)

export default component.exports